import TContractEditContractorInfo from './index.vue';

TContractEditContractorInfo.install = app => {
  app.component(TContractEditContractorInfo.name, TContractEditContractorInfo);
};

export default TContractEditContractorInfo;
